import { object } from 'prop-types';

/**
 * 这些类型不渲染成一组样式
 * @type {string[]}
 */
const NOT_RENDER_GROUP_TYPES: string[] = [
    'href',
];

/**
 * 这些类型样式在尾部输入或回车不继承。支持设置多个
 * @type {string[]}
 */
const MARK_NOT_EXTENDS_TYPES: string[] = [
    'href', 'raw-href', 'fieldType',
];

/**
 * 在textRun尾部回退删除时，会先删除该mark，而不会先删除文字
 * @type {string[]}
 */
const BACK_DELETE_MARK_TYPES: string[] = [
    'href',
];

export function stylesToMark(styles: any): any[] {
    if (!styles) return [];
    return Object.keys(styles).sort()  // 排序是为了做对比的时候，顺序一致，因为object.keys顺序是不固定的
        .map(key => styleToRawMark({
            [key]: styles[key],
        }));

    // TODO mark合并以后采用这种方式
    // return [{
    //     type: 'style',
    //     data: styles
    // }];
}

// { key: val } -> { type: key, data: { key: value }}
function styleToRawMark(style: any): any {
    const key = Object.keys(style)[0] || null;
    return key ? {
        type: key,
        renderGroup: isTypeRenderGroup(key),
        markNotExtend: isTypeMarkNotExtend(key),
        backDeleteMark: isTypeBackDeleteMark(key),
        data: {
            [key]: style[key],
        },
    } : {};
}

export function convertMarksToStyle(marks: any[]): any {
    return marks.reduce((prev, curr) => ({ ...prev, ...curr.data }), {});
}

/**
 * 该类型mark，是否需要render成一组style
 * @param type
 * @returns {boolean} 默认为true
 */
export function isTypeRenderGroup(type: string): boolean {
    for (let i = 0; i < NOT_RENDER_GROUP_TYPES.length; i++) {
        const notGroupType = NOT_RENDER_GROUP_TYPES[i];
        if (notGroupType === type) {
            return false;
        }
    }
    return true;
}

export function isTypeMarkNotExtend(type: string): boolean {
    for (let i = 0; i < MARK_NOT_EXTENDS_TYPES.length; i++) {
        const notExtendType = MARK_NOT_EXTENDS_TYPES[i];
        if (notExtendType === type) {
            return true;
        }
    }
    return false;
}

export function isTypeBackDeleteMark(type: string): boolean {
    for (let i = 0; i < BACK_DELETE_MARK_TYPES.length; i++) {
        const backDeleteMark = BACK_DELETE_MARK_TYPES[i];
        if (backDeleteMark === type) {
            return true;
        }
    }
    return false;
}
